<!--
  WCAG 4.1.3 (Status Messages). A search is the app's most-used interaction and it announced nothing:
  rows were replaced in place, so a screen reader user pressed Search and was told neither that
  anything had happened nor what came back. The visible count lives in the paginator, which is not a
  live region and is not read on a change.

  THE REGION IS ALWAYS IN THE DOM AND ONLY ITS TEXT CHANGES, which is the whole of making this work. A
  region that is itself `*ngIf`-ed into existence arrives in the same frame as its text, and a screen
  reader that was not already observing it commonly announces nothing -- the shape `npm run
  audit:liveregion` now refuses everywhere in the app. So the wrapper is unconditional and the
  branches below only choose which sentence it holds.

  It sits above both table-type branches deliberately: the EDIT grid and the normal table are two
  mutually exclusive `*ngIf`s, and a region inside either one would be destroyed and recreated when a
  list switched type, which is the same defect one level up.

  Visually hidden rather than rendered: the count is already on screen in the paginator, so this says
  the same thing to assistive tech only. `visually-hidden` is Bootstrap's own utility (loaded
  globally), which keeps the element in the accessibility tree -- unlike `display: none`, which would
  take the live region out of it and defeat the point.
-->
<div class="visually-hidden" role="status" data-testid="list-result-announcement">
  <ng-container [ngSwitch]="announcedTotal">
    <!-- Nothing has come back yet: the region exists but has nothing to say. -->
    <ng-container *ngSwitchCase="null"></ng-container>
    <ng-container *ngSwitchCase="0">{{ 'common.table.announceNoResults' | translate }}</ng-container>
    <ng-container *ngSwitchCase="1">{{ 'common.table.announceOneResult' | translate }}</ng-container>
    <!-- The keys are LITERALS in each branch rather than one key chosen in TypeScript: a key held in
         a variable is out of `audit:i18n` check 3's reach by construction, and that check is the only
         thing standing between a typo here and a dotted string being read aloud. -->
    <ng-container *ngSwitchDefault>{{ 'common.table.announceResults' | translate: { count: announcedTotal } }}</ng-container>
  </ng-container>
</div>

<ng-container *ngIf="typeTable && typeTable == 'EDIT' ; else normalTable">

    <app-table-edit-rows *ngIf="routeConf" [filtersOff]="currentSearch" [dataExtra]="dataExtra"
        [productStructureCond]="typeTableViewCondition" [getRowTable]="getRowTable"
        [displayedColumns]="displayedColumns" [config]="tableConfig" (rowSelect)="select($event)"
        (custom)="action($event)" [dataSource]="dataSource" (status)="tableStatusChange($event)"></app-table-edit-rows>

</ng-container>

<ng-template #normalTable>

    <ng-container *ngIf="strategySelect ; else noStrategy">

        <app-table *ngIf="routeConf" [rowOpens]="!!conf?.baseRoute" [onlycheck]="onlyCheck" [notInputPage]="notInputPage" (newPageSingle)="newPage($event)"
            [strategySelect]="strategySelect" [getRowTable]="getRowTable" [displayedColumns]="displayedColumns"
            [config]="tableConfig" (rowSelect)="select($event)" (custom)="action($event)" [dataSource]="dataSource"
            (status)="tableStatusChange($event)"></app-table>

    </ng-container>

    <ng-template #noStrategy>

        <app-table *ngIf="routeConf" [rowOpens]="!!conf?.baseRoute" [onlycheck]="onlyCheck" [notInputPage]="notInputPage" [getRowTable]="getRowTable"
            [displayedColumns]="displayedColumns" [config]="tableConfig" (rowSelect)="select($event)"
            (custom)="action($event)" [dataSource]="dataSource" (status)="tableStatusChange($event)"></app-table>

    </ng-template>

</ng-template>